/** @jsx jsx */
import { jsx } from '@emotion/react'
import React from 'react'
import { Container, Row, Col } from 'react-grid-system'

import H1 from '../typography/H1'
import H2 from '../typography/H2'
import ImageResponsive from '../images/ImageResponsive'
import P2 from '../typography/P2'
import { mq } from '../../theme'

interface Props {
  img: string
}

const AboutUsSection1: React.FC<Props> = (props) => {
  const { img } = props
  return (
    <div css={{ padding: '4em 0px' }}>
      <Container fluid={true}>
        <Row>
          <Col xs={12} md={6} push={{ md: 6 }}>
            <div css={{ maxWidth: '600px' }}>
              <H1 id="section2" css={[mq('mt0')]}>
                An Online Art Sourcing Management Tool for Industry
                Professionals
              </H1>
              <P2>
                The Artling Projects is a one-stop resource for finding artworks
                and design pieces for your projects. Catering to industry
                professionals, such as interior designers, architects and
                property developers, the tool aims to transform the art and
                design sourcing process by allowing users to manage their
                projects in one place.
              </P2>
              <H2>Simple. Quick. Automated.</H2>
            </div>
          </Col>
          <Col xs={12} md={6} pull={{ md: 6 }}>
            <ImageResponsive src={img} alt={''} />
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default AboutUsSection1
